import React from "react";
import { ChevronRight } from "lucide-react";



/* =========================================================
   MAIN CARD
========================================================= */

export default function Card4({ data }) {

  return (
    <main
      className={`
        relative
        min-h-screen
        overflow-hidden
        bg-cover
        bg-center
        bg-no-repeat
        px-4
        py-10
        ${data?.selectedTheme?.swatches?.light.bg}
      `}
    >

      {/* =================================================
          BACKGROUND DECORATION
      ================================================= */}

      <div
        className={`
          pointer-events-none
          absolute
          left-0
          top-0
          h-72
          w-72
          rounded-full
          ${data?.selectedTheme?.swatches?.primary.bg}
          opacity-20
          blur-3xl
        `}
      />
{/* Background */}
{data?.background?.type === "video" && data?.background?.url && (
  <video
    className="absolute inset-0 h-full w-full object-cover"
    src={data.background.url}
    autoPlay
    muted
    loop
    playsInline
  />
)}

{data?.background?.type === "image" && data?.background?.url && (
  <img
    src={data.background.url}
    alt="Background"
    className="absolute inset-0 h-full w-full object-cover"
  />
)}

{/* Theme background overlay - 20% opacity */}
{data?.background?.url && (
  <div
    className={`absolute inset-0 ${
      data?.selectedTheme?.swatches?.secondary?.bg || ""
    } opacity-20`}
  />
)}

{/* Profile content */}
<div className="relative z-10">
  {/* Your content */}
</div>

      <div
        className={`
          pointer-events-none
          absolute
          right-0
          top-1/4
          h-72
          w-72
          rounded-full
          ${data?.selectedTheme?.swatches?.secondary.bg}
          opacity-30
          blur-3xl
        `}
      />

      <div
        className={`
          pointer-events-none
          absolute
          bottom-0
          left-1/4
          h-72
          w-72
          rounded-full
          ${data?.selectedTheme?.swatches?.light.bg}
          opacity-60
          blur-3xl
        `}
      />

      {/* =================================================
          CONTENT
      ================================================= */}

      <div
        className="
          relative
          mx-auto
          flex
          w-full
          max-w-xl
          flex-col
          items-center
        "
      >

        {/* =================================================
            LOGO
        ================================================= */}

        <img
          src={
            data?.photo?.url ||
            "/logo512.png"
          }
          alt={
            data?.displayName ||
            "Logo"
          }
          className="
            mb-4
            h-48
            w-48
            rounded-full
            object-cover
            drop-shadow-xl
            sm:h-48
            sm:w-48
          "
        />

        {/* =================================================
            BRAND NAME
        ================================================= */}

        <h1
          className={`
            text-center
            text-3xl
            font-semibold
            tracking-wide
            ${data?.selectedTheme?.swatches?.primary.text}
            sm:text-4xl
          `}
        >
          {data?.displayName ||
            "Your Brand Name"}
        </h1>

        {/* DIVIDER */}

        <div
          className={`
            mt-2
            h-px
            w-36
            bg-gradient-to-r
            from-transparent
            via-current
            to-transparent
            ${data?.selectedTheme?.swatches?.primary.text}
          `}
        />

        {/* =================================================
            TAGLINE
        ================================================= */}

        <div className="mt-6 text-center">

          <p
            className={`
              font-serif
              text-3xl
              italic
              ${data?.selectedTheme?.swatches?.primary.text}
              sm:text-4xl
            `}
          >
            {data?.tagline ||
              "Tagline goes here"}
          </p>

          <p
            className={`
              mt-1
              text-xl
              tracking-wide
              ${data?.selectedTheme?.swatches?.primary.text}
              opacity-80
              sm:text-2xl
            `}
          >
            {data?.bio ||
              "Bio goes here"}
          </p>

        </div>

        {/* =================================================
            MAIN LINKS
        ================================================= */}

<div className="mt-6 flex w-full flex-col gap-4">
  {data.filteredLinks.map((link) => {
    const Icon = link.icon;
    const href = data.platformLinks[link.id];

    if (!href) return null;

    const style = link.style || {
      bg: "bg-gray-800",
      text: "text-white",
      border: "border-gray-800",
      hover: "hover:bg-gray-900",
    };

    return (
      <a
        key={link.id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`
          group
          flex
          w-full
          items-center
          gap-4
          rounded-full
          border
          bg-white/80
          p-3
          shadow-md
          transition-all
          duration-300
          hover:scale-[1.02]
          ${style.border}
          ${style.hover}
        `}
      >
        <div
          className={`
            flex
            h-12
            w-12
            shrink-0
            items-center
            justify-center
            rounded-full
            ${style.bg}
            ${style.text}
          `}
        >
          <Icon size={22} />
        </div>

        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold text-gray-900">
            {link.title}
          </p>

          <p className="truncate text-xs text-gray-500">
            {link.subtitle}
          </p>
        </div>

        <div
          className={`
            flex
            h-10
            w-10
            items-center
            justify-center
            rounded-full
            ${style.bg}
            ${style.text}
          `}
        >
          <ChevronRight size={18} />
        </div>
      </a>
    );
  })}
</div>
        {/* =================================================
            SOCIAL ICONS
        ================================================= */}

{/* =================================================
    SOCIAL ICONS
================================================= */}

<div className="mt-8 flex w-full items-center justify-center gap-4">
  {data.socialLinks.map((link) => {
    const Icon = link.icon;

    const style = link.style || {
      bg: "bg-gray-800",
      text: "text-white",
      border: "border-gray-800",
      hover: "hover:bg-gray-900",
    };

    return (
      <a
        key={link.id}
        href={data.platformLinks[link.id]}
        target="_blank"
        rel="noopener noreferrer"
        className={`
          flex
          h-12
          w-12
          shrink-0
          items-center
          justify-center
          rounded-full
          border
          transition-all
          duration-300
          hover:scale-110
          ${style.bg}
          ${style.text}
          ${style.border}
          ${style.hover}
        `}
        aria-label={link.label}
      >
        <Icon size={21} />
      </a>
    );
  })}
</div>

        {/* =================================================
            FOOTER
        ================================================= */}

        <div
          className="
            mt-10
            pb-6
            text-center
          "
        >

          <p
            className={`
              font-serif
              text-2xl
              italic
              ${data?.selectedTheme?.swatches?.primary.text}
            `}
          >
            Thank you for
            supporting ♡
          </p>

          <p
            className={`
              mt-3
              text-xs
              tracking-[0.4em]
              ${data?.selectedTheme?.swatches?.primary.text}
              opacity-70
            `}
          >
            {data?.displayName ||
              "ZEEDBIO"}
          </p>

        </div>

      </div>
    </main>
  );
}